<template>
  <div>
    <div class="page-header page-header-small clear-filter">
      <parallax
        class="page-header-image"
        style="background-image:url('img/bg8.jpg')"
      >
      </parallax>
        <div class="content-center brand">
          <h1 class="h1-seo">Partners</h1>
        </div>
    </div>
      <section id="team" class="section section-team text-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-lg-8">
        <div class="team">
          <div class="row justify-items-center">
            <div class="col-sm-6 col-xl-4 pb-4" v-for="partner in partners" :key="partner.title">
              <div class="partner">
                <div class="partner-wrapper">
                <img
                  class="mx-auto"
                  :src="'img/partners/' + partner.img"
                />
                </div>
                <div class="partner-text">
                <p class="category pt-2 mb-0">{{partner.text}}</p>
                </div>
              </div> 
            </div>
          </div>
        </div>
          </div>
          </div>
      </div>
    </section>
    </div>
</template>
<script>
import { Parallax } from '@/components';

export default {
  name: 'index',
  bodyClass: 'index-page',
  data() {
    return {
      partners: [{title:'Bolder', text: 'Fund Administrator', img:'Bolder_Logo.png'}, {title:'Darwin', text:'Depositary', img:'Darwin.jpg'}, {title: 'Interactive', text: '(Clearing) Broker', img:'Interactive-Brokers.png'},{title: 'O2', text: 'Auditor', img:'O2_logo.png'}, {title: 'Rabobank', text: 'Bank', img:'rabobank.png'}, {title: 'Van Campen', text: 'Legal Advisor', img:'VanCampen-Liem.png'}]
    }
  },
  components: {
    Parallax
  }
};
</script>
<style>
.partner {
  height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.partner-text {
  display: flex;
  flex-direction: column;
}
.partner-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
